import * as React from "react";
const SvgPinkStoke = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 2, viewBox: "0 0 20 2", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 1C14.0775 1 19.199 1 20 1", stroke: "#FF4C98", strokeWidth: 2 }));
export default SvgPinkStoke;
